import { Box } from "@mui/material";
import React from "react";
import AdminReassign from "@pages/AdminReassign";
import AdminUsers from "@pages/AdminUsers";

const sectionSx = {
  backgroundColor: "#fff",
  border: "1px solid #e8eaf0",
  borderRadius: "8px",
  padding: "16px 20px",
};

const AdminPortal = () => (
  <Box
    sx={{
      padding: "16px 20px 24px",
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
    }}
  >
    <Box sx={sectionSx}>
      <AdminUsers />
    </Box>
    <Box sx={sectionSx}>
      <AdminReassign />
    </Box>
  </Box>
);

export default AdminPortal;
